import { jsx as i, jsxs as z, Fragment as T } from "react/jsx-runtime";
import k, { useState as A, useId as v, useEffect as P, cloneElement as q } from "react";
import { c as m } from "../clsx-OuTLNxxd.js";
import { A as w, E as j } from "../index-Dlw4JYvo.js";
import '../Accordion.css';const L = "320px", U = "600px", R = "1025px", G = "_header_5bn93_33", J = "_splitHeader_5bn93_37", K = "_iconSlot_5bn93_43", Q = "_heading_5bn93_50", X = "_toggle_5bn93_57", Y = "_triggerElement_5bn93_66", Z = "_indicator_5bn93_69", O = "_trigger_5bn93_66", V = "_contentElement_5bn93_91", M = "_primary_5bn93_96", D = "_content_5bn93_91", C = "_secondary_5bn93_99", N = "_item_5bn93_105", ee = "_dense_5bn93_105", te = "_nav_5bn93_198", ne = "_link_5bn93_203", ie = "_headingText_5bn93_235", oe = "_linkLabel_5bn93_236", re = "_linkList_5bn93_263", t = {
  mobile: L,
  "mobile-wide": "480px",
  tablet: U,
  "tablet-wide": "800px",
  desktop: R,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  header: G,
  splitHeader: J,
  iconSlot: K,
  heading: Q,
  toggle: X,
  triggerElement: Y,
  indicator: Z,
  trigger: O,
  contentElement: V,
  primary: M,
  content: D,
  secondary: C,
  item: N,
  dense: ee,
  nav: te,
  link: ne,
  headingText: ie,
  linkLabel: oe,
  linkList: re
}, ce = (r) => {
  if (typeof requestAnimationFrame != "function")
    return r(), () => {
    };
  let x = 0;
  const c = requestAnimationFrame(() => {
    x = requestAnimationFrame(r);
  });
  return () => {
    cancelAnimationFrame(c), cancelAnimationFrame(x);
  };
}, le = ({
  animationDurationMs: r = 0,
  indicatorSize: x = "s",
  isOpen: c,
  onChange: e,
  stroke: p = "bold"
}) => {
  const [o, l] = A(c), s = r > 0, [u, h] = A(c), [W, y] = A(!1), g = v(), f = v(), _ = () => {
    e == null || e(!o), l(!o);
  };
  P(() => {
    c !== o && l(c);
  }, [c]), P(() => {
    if (!s) return;
    if (o)
      return h(!0), ce(() => y(!0));
    y(!1);
    const n = setTimeout(() => h(!1), r);
    return () => clearTimeout(n);
  }, [o, s, r]);
  const b = {
    "aria-controls": f,
    "aria-expanded": o,
    "data-state": o ? "open" : "closed",
    id: g,
    onClick: _
  }, H = {
    "aria-labelledby": g,
    className: t.contentElement,
    hidden: s ? !u : !o,
    id: f,
    role: "region",
    ...s && W ? { "data-enter": "" } : {}
  };
  return {
    headingProps: b,
    sectionProps: H,
    triggerClass: t.triggerElement,
    Indicator: () => p === "bold" ? /* @__PURE__ */ i(w, { className: t.indicator, size: x }) : /* @__PURE__ */ i(j, { className: t.indicator, size: x })
  };
}, de = ({
  animationDurationMs: r = 0,
  chevronStroke: x = "bold",
  children: c,
  classNames: e,
  heading: p,
  headingAs: o = "h3",
  icon: l,
  indicator: s,
  indicatorSize: u = "s",
  isDense: h = !1,
  isOpen: W = !1,
  links: y,
  onChange: g,
  onLinkClick: f,
  testId: _,
  toggleLabel: b,
  trackingAttribute: H,
  variant: n
}) => {
  const { Indicator: a, headingProps: d, sectionProps: B, triggerClass: E } = le({
    animationDurationMs: r,
    isOpen: W,
    onChange: g,
    indicatorSize: u,
    stroke: x
  }), I = {
    ...d,
    ...H ? { "data-analytics": H } : {},
    ..._ ? { "data-testid": _ } : {},
    type: "button"
  }, { id: F, ...$ } = I;
  return /* @__PURE__ */ z(
    "div",
    {
      className: m(
        t.item,
        { [t.dense]: h },
        n && n !== "bare" && t[n],
        e == null ? void 0 : e.wrapper
      ),
      children: [
        /* @__PURE__ */ i(o, { className: m(t.header, { [t.splitHeader]: b }, e == null ? void 0 : e.header), children: b ? /* @__PURE__ */ z(T, { children: [
          /* @__PURE__ */ z("span", { className: m(t.heading, e == null ? void 0 : e.heading), id: F, children: [
            l !== void 0 && /* @__PURE__ */ i("span", { className: t.iconSlot, children: l }),
            p
          ] }),
          /* @__PURE__ */ i(
            "button",
            {
              "aria-label": b,
              className: m(E, t.toggle, e == null ? void 0 : e.button),
              ...$,
              children: s ?? /* @__PURE__ */ i(a, {})
            }
          )
        ] }) : /* @__PURE__ */ z("button", { className: m(E, t.trigger, e == null ? void 0 : e.button), ...I, children: [
          l === void 0 ? p : /* @__PURE__ */ z(T, { children: [
            /* @__PURE__ */ i("span", { className: t.iconSlot, children: l }),
            /* @__PURE__ */ i("span", { className: m(t.headingText, e == null ? void 0 : e.heading), children: p })
          ] }),
          s ?? /* @__PURE__ */ i(a, {})
        ] }) }),
        /* @__PURE__ */ i(
          "div",
          {
            ...B,
            className: m(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${r}ms` },
            children: y ? /* @__PURE__ */ i("ul", { className: t.linkList, children: y.map((S) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ z("a", { className: t.link, href: S.href, onClick: () => f == null ? void 0 : f(S), children: [
              /* @__PURE__ */ i("span", { className: t.iconSlot, children: S.icon }),
              /* @__PURE__ */ i("span", { className: t.linkLabel, children: S.label })
            ] }) }, `${S.href}-${S.label}`)) }) : c
          }
        )
      ]
    }
  );
}, xe = ({
  chevronStroke: r = "bold",
  children: x,
  defaultOpen: c,
  indicatorSize: e = "s",
  isDense: p = !1,
  name: o,
  onValueChange: l,
  type: s = "single",
  value: u,
  variant: h = "primary"
}) => {
  const W = s === "multiple", y = u !== void 0, g = k.Children.toArray(x), f = c ? g.map(() => !0) : g.map((n) => !!n.props.isOpen), [_, b] = A(f), H = (n, a) => {
    let d = [];
    W ? (d = [..._], d[a] = n) : (d = g.map(() => !1), n === !0 && (d[a] = !0)), b(d);
  };
  return /* @__PURE__ */ i("div", { className: m(t.accordion, h !== "bare" && t[h]), "data-testid": "accordion-component", children: x && g.map(
    (n, a) => (
      // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
      // so adding one to `AccordionItemProps` does not also require adding it here.
      q(n, {
        chevronStroke: r,
        indicatorSize: e,
        isDense: p,
        variant: h,
        isOpen: y ? n.props.value === u : _[a],
        key: `${o}-item-${a}`,
        onChange: (d) => {
          var B, E;
          (E = (B = n.props).onChange) == null || E.call(B, d), y ? l == null || l(d ? n.props.value ?? null : null) : H(d, a);
        }
      })
    )
  ) });
};
xe.Item = de;
export {
  xe as Accordion,
  le as useToggle
};
